export default {
  title: 'My Personal Information',
  label: {
    information: 'My Personal Information',
    name: 'Name',
    email: 'Email',
    mobile: 'Mobile ID',
    id: 'ID',
    myApplication: 'My Applications',
    application: 'Applications',
    inCompleteApplication: 'Incomplete Applications',
    myConsent: 'My Consent'
  },
  message: {
    weChatBindSuccess: 'You will get paid to your WeChat Wallet when you successfully earn the referral rewards.',
    weChatBindFailed: 'Your WeChat account has already been linked to another account. Please use a different WeChat account to bind.'
  }
}
